import type { TMainCategory, TSinglePlayerGameType } from "@/store/index.js";
import { axios } from "./config.js";
import type {
	TAuthVerifyCreate,
	TAuthVerifyResend,
	TAxiosGenRes,
	TBasicType,
	TForgotPass,
	TLoginParam,
	TLoginRes,
	TResetPass,
	TPostsGet,
	TUsersGet,
	TUsersAdd,
	TUsersEdit,
	TCategoriesGet,
} from "./types";

export default {
	// Auth
	authRegister: (params: any) =>
		axios.post<TAxiosGenRes<TBasicType>>("auth/register", params),
	authRenewSession: () =>
		axios.post<{ data: { data: string } }>("auth/renew-session"),
	authLogout: () => axios.get("auth/logout", { validateStatus: null }),
	authVerifyCreate: (params: TAuthVerifyCreate) =>
		axios.post<TLoginRes>("auth/verify", params),
	authVerifyResend: (params: TAuthVerifyResend) =>
		axios.put("auth/verify", params),
	authForgot: (params: TForgotPass) =>
		axios.post("auth/forgot-password", params),
	authResetPass: (params: TResetPass) =>
		axios.put("auth/forgot-password", params),
	// DaiDai - Auth
	authLogin: (params: TLoginParam) =>
		axios.post<TLoginRes>("auth/login", params),
	authCheckJwt: () => axios.get("auth/check-jwt"),
	// Blog
	postsAdd: (params: FormData) => axios.post("posts/posts-add", params),
	postsEdit: (params: FormData) => axios.post("posts/posts-edit", params),
	postsGet: (params: TPostsGet) => axios.get("posts/posts-get", { params }),
	postsRemove: (params: { pst_id: number }) =>
		axios.post("posts/posts-remove", params),
	usersGet: (params: TUsersGet) => axios.get("users/users-get", { params }),
	usersEdit: (params: FormData | TUsersEdit) =>
		axios.post("users/users-edit", params),
	usersAdd: (params: TUsersAdd) => axios.post("users/users-add", params),
	usersRemove: (params: { usr_id: number }) =>
		axios.post("users/users-remove", params),
	// tagsGet: (params: any) => axios.get("tags/tags-get", { params }),
	// tagsAdd: (params: { tag_label: string }) =>
	// 	axios.post("tags/tags-add", params),
	// tagsRemove: (params: { tag_id: number }) =>
	// 	axios.post("tags/tags-remove", params),
	tagsEdit: (params: { tag_id: number; tag_label: string }) =>
		axios.post("tags/tags-edit", params),

	/**
	 *
	 */

	categoriesGet: (params: TCategoriesGet) =>
		axios.get("categories/categories-get", { params }),
	categoriesTreeGet: (params: TCategoriesGet) =>
		axios.get("categories/categories-get-tree", { params }),
	categoriesRemove: (params: { cat_id: number }) =>
		axios.post("categories/categories-remove", params),
	categoriesEdit: (params: { cat_id: number; cat_name: string }) =>
		axios.post("categories/categories-edit", params),
	categoriesAdd: (params: { cat_name: string; cat_id_parent?: number }) =>
		axios.post("categories/categories-add", params),
	geoscopesGet: (params: { search?: string }) =>
		axios.get("geoscopes/geoscopes-get", { params }),
	geoscopesEdit: (params: { gsc_id: number; gsc_name: string }) =>
		axios.post("geoscopes/geoscopes-edit", params),
	geoscopesRemove: (params: { gsc_id: number }) =>
		axios.post("geoscopes/geoscopes-remove", params),
	geoscopesAdd: (params: { gsc_name: string }) =>
		axios.post("geoscopes/geoscopes-add", params),
	entitiesGet: (params: { search?: string; ent_id?: number }) =>
		axios.get("entities/entities-get", { params }),
	entitiesEdit: (params: { ent_id: number; ent_name?: string }) =>
		axios.post("entities/entities-edit", params),
	entitiesAdd: (params: { ent_name: string; ent_summary: string }) =>
		axios.post("entities/entities-add", params),
	entitiesRemove: (params: { ent_id: number }) =>
		axios.post("entities/entities-remove", params),

	/**
	 *
	 */

	getUser: (params: { token: string | null }) =>
		axios.get("users/get-user", { params }),
	getWhatsNew: (params: { token: string | null }) =>
		axios.get("users/get-whats-new", { params }),
	getFilterPresets: (params: { token: string | null }) =>
		axios.get("people/get-filter-presets", { params }),
	editUser: (params: {
		token: string;
		name?: string;
		genreIds?: number[];
		originCountryCodes?: string | null;
		moviePopularity?: "all" | "popular";
		minMovieYear?: string | null;
		maxMovieYear?: string | null;
		showOriginalTitle?: boolean | null;
		peopleOnlyGloballyKnown?: 1 | 0;
		peopleFilterPresetCode?: string | null;
	}) => axios.post("users/edit-user", params),
	getLeaderboard: (params: {
		token: string;
		type: TSinglePlayerGameType;
		category: TMainCategory;
	}) => axios.get("users/get-leaderboard", { params }),

	getMoviesInitialPair: (params: {
		token: string;
		type: TSinglePlayerGameType;
		genreIds?: number[] | null;
		fromYear?: string | null;
		toYear?: string | null;
		countryCodes?: string[] | null;
		popularity?: "all" | "popular";
	}) => axios.post("movies/movies-get-pair", params),

	postHandleAnswer: (params: {
		round?: number | null;
		vote: string | number;
		token: string;
		minMovieYear?: string | null;
		maxMovieYear?: string | null;
		genreIds?: number[] | null;
		countryCodes?: string[] | null;
		popularity?: "all" | "popular";
	}) => axios.post("movies/movies-handle-answer", params),
	postBTCHandleAnswer: (params: {
		// round?: number | null;
		vote: string | number;
		token: string;
		minMovieYear?: string | null;
		maxMovieYear?: string | null;
		genreIds?: number[] | null;
		countryCodes?: string[] | null;
		popularity?: "all" | "popular";
	}) => axios.post("movies/movies-btc-handle-answer", params),
	postBTCGameExpired: (params: { token: string }) =>
		axios.patch("movies/movies-btc-handle-answer", params),
	getMoviesSinglePayerState: (params: {
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.get("movies/movies-get-single-player-state", { params }),
	// getMoviesStats: (params: { token: string; type: TSinglePlayerGameType }) =>
	// 	axios.get("movies/movies-get-stats", { params }),
	getMovieGenres: (params: { token: string }) =>
		axios.get("movies/get-genres", { params }),
	getMovieOriginCountries: (params: { token: string }) =>
		axios.get("movies/get-origin-countries", { params }),

	// music

	getMusicInitialPair: (params: {
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.get("music/music-get-pair", { params }),
	getMusicSinglePayerState: (params: {
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.get("music/music-get-single-player-state", { params }),
	postMusicHandleAnswer: (params: {
		round?: number | null;
		vote: string | number;
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.post("music/music-handle-answer", params),
	postMusicBTCHandleAnswer: (params: {
		vote: string | number;
		token: string;
	}) => axios.post("music/music-btc-handle-answer", params),
	postMusicBTCGameExpired: (params: { token: string }) =>
		axios.patch("music/music-btc-handle-answer", params),

	// people

	getPeopleInitialPair: (params: {
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.get("people/people-get-pair", { params }),
	getPeopleSinglePayerState: (params: {
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.get("people/people-get-single-player-state", { params }),
	postPeopleHandleAnswer: (params: {
		vote: string | number;
		token: string;
		type: TSinglePlayerGameType;
	}) => axios.post("people/people-handle-answer", params),
	postPeopleBTCHandleAnswer: (params: {
		vote: string | number;
		token: string;
	}) => axios.post("people/people-btc-handle-answer", params),

	getAdminPanelPeople: (params: {
		page: number;
		limit: number;
		search?: string | null;
	}) => axios.get("admin-panel/people-get", { params }),
	editAdminPanelPeople: (params: {
		peopleIds: (number | string)[];
		isGloballyKnown: 1 | 0;
	}) => axios.post("admin-panel/people-edit", params),

	postMultiplayerPlayAgain: (params: { mpg_token: string; token: string }) =>
		axios.post("websockets/multiplayer-play-again", params),
};
